import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectAllProposals, selectAllProviderOffers } from 'src/app/common/store/state/app.state';
import { ProviderOfferDialogComponent } from '../provider-offer-dialog/provider-offer-dialog.component';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { MatCalendar } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TableDialogComponent } from 'src/app/public/common/components/table-dialog/table-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { CarBusinessLine } from '../../constants/car-basic-data';
import { Car } from '../../models/car.model';

@Component({
    selector: 'app-provider-offers',
    templateUrl: './provider-offers.component.html',
    styleUrls: ['./provider-offers.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule, MatIconModule, MatDividerModule]
})
export class ProviderOffersComponent {

  //@Input() proposals: Proposal[] = [];
  @Input() objectSource: ObjectSource = ObjectSource.PARK;
  @Input() businessLine: CarBusinessLine = CarBusinessLine.BUY;
  @Input() carId: string = "";
  @Input() enableNew: boolean = false;

  providerOffers$: Observable<Car[]>;
  providerOffers: Car[] = [];

  ObjectSource = ObjectSource;
  CarBusinessLine = CarBusinessLine

  constructor(
      private router: Router,
      private store: Store, 
      public dialog: MatDialog) {
      this.providerOffers$ = this.store.select(selectAllProviderOffers(this.objectSource, this.carId, this.businessLine))
 
  }
     
  ngOnInit(): void {

    this.providerOffers$ = this.store.select(selectAllProviderOffers(this.objectSource, this.carId, this.businessLine))
          
    this.providerOffers$.subscribe(
      (result: Car[]) => this.providerOffers = result
    );

  }

   openProviderOfferDialog(carId: string, offerId: string, businessLine: CarBusinessLine): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, offerId, 0, businessLine );
    objectData.carId = carId;

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProviderOfferDialogComponent, {
      data: objectData
    });

  }

  /*
  openProviderOfferDialog(carId: string, businessLine: CarBusinessLine): void {
  
      let car: Car = new Car();
      car.businessLine = businessLine
      car.carId = carId
      car.country = this.currentDealer.countryResident
      //car.country = 
      //console.log(offer);
   
      const dialogRef = this.dialog.open(ProviderOfferDialogComponent, {
        //data: Object.assign(new Car(), this.car)
        //data: structuredClone(this.car)
        data: structuredClone(car)
      });
  
      dialogRef.afterClosed().subscribe((result: any) => {
  
        if(result != undefined ){
          
          console.log(result)
          if(result.offerId === ''){
            console.log(result)
            this.store.dispatch(DealerActions.providerOfferNewSubmit({ providerOffer: result }));
          }
          else{
            this.store.dispatch(DealerActions.providerOfferUpdateSubmit({ providerOffer: result }));
          }
        }    
      });
    }
  
  
  openProposalDialog(proposalId: number, isReschedule: boolean): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.offerId, proposalId );

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    if(isReschedule){
      let instance = dialogRef.componentInstance
      instance.isReschedule = isReschedule
    }
  }

  
  openProposalDialogOld(prop?: Proposal): void {
  
      //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
      let proposal: Proposal;
  
      if(prop !== undefined){
        proposal = JSON.parse(JSON.stringify(prop!));
        //console.log('hello 1')
        
      }else{
        proposal = new Proposal();
        proposal.carId = this.carId!;
        //console.log('hello 2')
      }
  
      let isReschedule: boolean = (proposal.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited
  
      //console.log('prop = '+JSON.stringify(carId));
      const dialogRef = this.dialog.open(ProposalDialogComponent, {
        data: proposal
      });
      
      dialogRef.afterClosed().subscribe((result: Proposal) => {
  
        //console.log('helloo = '+JSON.stringify(result));
        
        if(result != undefined ){
  
          //console.log('New proposal = '+result.status+ " date = "+result.proposalDate+ " car Id = "+JSON.stringify(result));
          if(result.id === ''){
            console.log('new')
            this.store.dispatch(BuyActions.proposalNewSubmit ( { proposal: result }));
            return;
          }
  
          if(isReschedule){
            console.log('reschedule')
            this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: result.id, rescDate: result.rescheduleDate }));
            return;
          }
  
          else{
            console.log('update')
            this.store.dispatch(BuyActions.proposalUpdateSubmit ( { proposal: result }));          
            return;
          } 
        }  
      });
    }
  */

    deleteOffer(carId: string, providerOfferId: string, businessLine: CarBusinessLine){
     this.store.dispatch(DealerActions.providerOfferDeleteSubmit( { carId: carId, providerOfferId: providerOfferId, businessLine: businessLine, objectSource: this.objectSource }));
    }

    toggleOfferPostedStatus(carId: string, providerOfferId: string, businessLine: CarBusinessLine){
  
      console.log('heyy  po '+status.toString());
  
      this.store.dispatch(DealerActions.providerOfferTogglePostedSubmit ( { carId: carId, providerOfferId: providerOfferId, businessLine: businessLine, objectSource: this.objectSource }));
      
      console.log('heyy  po1 '+status.toString());
  
    }

    toggleOfferClosedStatus(carId: string, providerOfferId: string, businessLine: CarBusinessLine){
  
      console.log('heyy cl  '+status.toString());
  
      this.store.dispatch(DealerActions.providerOfferToggleClosedSubmit ( { carId: carId, providerOfferId: providerOfferId, businessLine: businessLine, objectSource: this.objectSource }));
      console.log('heyy cl1  '+status.toString());
    }

    openPriceHistoryDialog(history: Price[], businessLine: CarBusinessLine): void {
    
        const dialogRef = this.dialog.open(TableDialogComponent, {
          data: {priceHistory: history, businessLine: businessLine, label: "Price"}
        });
    
        dialogRef.afterClosed().subscribe(() => {
      
        });
      }
  
    goToOfferPage(offerId: string, businessLine: CarBusinessLine): any{

      //console.log("navigate to "+offerId);
      this.router.navigate(
        ['/provider/'+businessLine.toString().toLowerCase()+'-offer'],
        { fragment: offerId }
      );
    }

    dateFormat(dt: string): string{
    
      return AppFunctions.stringToDatetime(dt);
    }

    moneyFormat(dt: string): string{
  
      return AppFunctions.numberWithComma(dt);
    }

}
